import Spinners from "components/Common/Spinner"
import FullPageLoader from "components/fullPageLoader"
import { sweetAlertClasses } from "helpers/common"
import React, { useEffect, useRef, useState } from "react"
import toast from "react-hot-toast"
import { useSelector } from "react-redux"

import { Row, Col } from "reactstrap"
import {
  useGenerateTemplateTokenMutation,
  useLazyGetStatusOfOldDigioRequestQuery,
  useUpdateDiogioRequestStatusMutation,
} from "store/api/kyc/kyc"
import Swal from "sweetalert2"

const IDVerification = ({ kycData, profileData }) => {
  const { user } = useSelector((state) => state.user)
  const [isLoading, setIsLoading] = useState(false)
  const [requestData, setRequestData] = useState(null)
  const [loader, setLoader] = useState(false)
  const [getToken, { isLoading: isFetching }] =
    useGenerateTemplateTokenMutation()
  const [getRequestStatus] = useLazyGetStatusOfOldDigioRequestQuery()
  const [updateDiogioRequestTrigger] = useUpdateDiogioRequestStatusMutation()
  const intervalRef = useRef(null)
  const template_name = "DIGILOCKER_AADHAAR_PAN_ICD"

  useEffect(() => {
    if (user && user.entity_type === "INDIVIDUAL" && kycData) {
      if (
        kycData?.investorsPAN &&
        kycData.pan_no !== kycData?.investorsPAN?.pan
      ) {
        Swal.fire({
          title: "Error!",
          html: `<p>The PAN document you have uploaded does not match the PAN associated with your registration link.</p>

              <p>Please ensure that you upload the correct PAN linked to your registration.</p>

              <p>You may choose to:</p>
              <ul style="list-style: none;">
                <li>Re-upload PAN, OR</li>
                <li>Contact Support for assistance</li>
              </ul>`,
          icon: "error",
          confirmButtonColor: "#BD0000",
          confirmButtonText: "Got it",
          customClass: { ...sweetAlertClasses },
        })
      }
    }
  }, [user, kycData])

  useEffect(() => {
    onGetRequestStatus()

    return () => {
      if (intervalRef) {
        clearInterval(intervalRef.current)
      }
    }
  }, [])

  const onGetRequestStatus = async () => {
    try {
      const { data } = await getRequestStatus({ template_name }).unwrap()
      setRequestData(data)
      if (data.status === "kyc.request.approved" && intervalRef?.current) {
        window.location.reload()
        clearInterval(intervalRef.current)
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (kycData && requestData) {
      if (
        profileData.status === "PENDING" &&
        requestData.status === "kyc.request.completed" &&
        requestData.kyc_status === "KYC_PENDING"
      ) {
        setLoader(true)
        const id = setInterval(() => {
          onGetRequestStatus()
        }, 5000)
        intervalRef.current = id
      }
    }
  }, [requestData, kycData])

  const startKYC = async () => {
    try {
      setIsLoading(true)
      const { data, success, message } = await getToken({
        template_name,
      }).unwrap()

      if (success) {
        if (window.Digio) {
          const options = {
            environment: "sandbox", //<sandbox, production>
            callback: function (response) {
              if (response.hasOwnProperty("error_code")) {
                console.log("Error occurred in process", response)
              } else {
                updateDiogioRequestTrigger({
                  id: response.digio_doc_id,
                }).unwrap()
                setLoader(true)
                setTimeout(() => {
                  setLoader(false)
                  window.location.reload()
                }, 10000)
              }
            },
            event_listener: function (event) {
              console.log("event_listener", event)
            },
            is_iframe: true,
            theme: {
              primaryColor: "#000000",
              secondaryColor: "#000000",
            },
          }
          if (data?.documentId) {
            const digio = new window.Digio(options)
            digio.init()

            const documentId = data.documentId
            const identifier = data.identifier
            const tokenId = data.tokenId

            digio.submit(documentId, identifier, tokenId)
          }
          // If using token approach:
        } else {
          console.error("Digio SDK not loaded")
        }
      } else {
        toast.error(message, { id: "toastMessage" })
      }
    } catch (error) {
      toast.error("Something went wrong, Please try again after sometime", {
        id: "toastMessage",
      })
    } finally {
      setIsLoading(false)
    }
  }

  if (loader) return <FullPageLoader />

  return (
    <>
      <Row>
        <div className="id-verification-wrapper">
          <h5 className="heading">Please have the following details ready</h5>
          <p>
            Each Investor must complete their KYC before Investing. You'll need
            to upload documents listed below to complete your KYC.
          </p>
          <div className="id-verification-details">
            <div className="id-verification-card">
              <h5>Aadhar Card </h5>
              <p>To verify your identity</p>
            </div>
            <div className="id-verification-card">
              <h5>Pan Card </h5>
              <p>To verify your identity</p>
            </div>
            {user?.entity_type === "INDIVIDUAL" && (
              <>
                <div className="id-verification-card">
                  <h5>Bank Details </h5>
                  <p>To verify your Banking details</p>
                </div>
                <div className="id-verification-card">
                  <h5>Demat Details </h5>
                  <p>To transfer securities when you invest on Prachay</p>
                </div>
              </>
            )}
          </div>
          <Col xl={12}>
            <div className="d-flex align-items-center my-4">
              <button
                type="submit"
                className="btn btn-primary w-100"
                onClick={() => startKYC()}
              >
                {isLoading || isFetching ? <Spinners /> : "Start KYC"}
              </button>
            </div>
          </Col>
        </div>
      </Row>
    </>
  )
}

export default IDVerification
